module.exports = __webpack_public_path__ + "img/stopwatch_1.6ba27716.png";